// extracted by mini-css-extract-plugin
module.exports = {"newnight":"StoryNewNight_newnight__C0N0E","mobile_newnight":"StoryNewNight_mobile_newnight__pRmOh"};